import React from 'react';
import { Badge } from '@roger/ui-components';
import type { DisciplineType } from '../../services/api/models/DisciplineType';
import { getDisciplineColor } from '../../utils/worksheetGoals';

/** Pill showing a discipline code, colored per discipline. */
const DisciplineBadge: React.FC<{ discipline: string }> = ({ discipline }) => (
  <Badge
    variant='outline'
    className={`border px-2 py-0.5 text-xs whitespace-nowrap ${getDisciplineColor(discipline as DisciplineType)}`}
  >
    {discipline}
  </Badge>
);

export default DisciplineBadge;
